// composables/useFeedback.ts
//
// The toasts the interaction patterns prescribe: success after a command, worded
// `{Aggregate} {reference} added|updated|deleted`, and error for anything that is not the outcome
// of the command the user is looking at (a failed list fetch, a 500, a network error).
import { useToast } from 'primevue/usetoast';
import { describeApiError } from '@/api/problemDetails';

export function useFeedback() {
    const toast = useToast();

    return {
        success(summary: string) {
            toast.add({ severity: 'success', summary, life: 3000 });
        },
        //a command that went through, with something the user should check
        warn(summary: string) {
            toast.add({ severity: 'warn', summary, life: 6000 });
        },
        error(summary: string, error?: unknown) {
            toast.add({ severity: 'error', summary, detail: error === undefined ? undefined : describeApiError(error).message, life: 6000 });
        }
    };
}
